"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { usePersona } from "@opensea/navigation";
import { isAddressEqual } from "@opensea/utils";
import { usePurchaseFlow } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { isBulkActionEnabled } from "@/constants/constants";
import { useAddress } from "@/hooks/wallet";
import { useBuyItemsFragment } from "./use-buy-items.fragment";
import { isItemListed } from "./validation/listing";
import { isItemTradable } from "./validation/tradable";
export const useBuyItems = (itemKeys, options) => {
  const $ = _c(10);
  const t = useTranslations("useBuyItems");
  const items = itemKeys.map(_temp);
  const address = useAddress();
  const {
    persona
  } = usePersona();
  const mode = persona === "advanced" ? "minimized" : "full";
  let t0;
  if ($[0] !== mode) {
    t0 = {
      mode
    };
    $[0] = mode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const purchaseFlow = usePurchaseFlow(t0);
  const getDisabledReason = () => {
    if (items.some(item => typeof item !== "undefined" ? !(isItemListed(item) || options?.hasBuyQuote) : false)) {
      return t("errors.unlistedItems");
    }
    if (items.some(_temp2)) {
      return t("errors.untradeableItems");
    }
    if (items.some(item_1 => item_1?.chain.identifier !== items[0]?.chain.identifier)) {
      return t("errors.differentChains");
    }
    if (items.some(item_2 => isAddressEqual(item_2?.bestListing?.maker.address, address))) {
      return t("errors.ownListing");
    }
    if (items.some(_temp3)) {
      return t("errors.tradingDisabled");
    }
    if (items.filter(_temp4).length > 1) {
      return t("errors.bulkActionsUnavailable");
    }
  };
  const disabledReason = getDisabledReason();
  const disabled = Boolean(disabledReason);
  let t1;
  if ($[2] !== items || $[3] !== options?.isClaim || $[4] !== purchaseFlow) {
    t1 = function buyItems() {
      if (items.length) {
        purchaseFlow(items.flatMap(_temp5), {
          isClaim: options?.isClaim
        });
      }
    };
    $[2] = items;
    $[3] = options?.isClaim;
    $[4] = purchaseFlow;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const buyItems = t1;
  let t2;
  if ($[6] !== buyItems || $[7] !== disabled || $[8] !== disabledReason) {
    t2 = {
      disabled,
      disabledReason,
      buyItems
    };
    $[6] = buyItems;
    $[7] = disabled;
    $[8] = disabledReason;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
function _temp(itemKey) {
  const readItem = readFragment(useBuyItemsFragment, itemKey);
  return readItem?.tokenId ? {
    ...readItem,
    quantity: itemKey?.quantity,
    orderId: itemKey?.orderId
  } : undefined;
}
function _temp2(item_0) {
  return typeof item_0 !== "undefined" ? !isItemTradable(item_0) : false;
}
function _temp3(item_3) {
  return !isItemTradable(item_3);
}
function _temp4(item_4) {
  return !isBulkActionEnabled(item_4?.collection?.slug);
}
function _temp5(item_5) {
  return item_5 ? [{
    chain: {
      identifier: item_5.chain.identifier
    },
    contractAddress: item_5.contractAddress,
    tokenId: item_5.tokenId,
    quantity: item_5.quantity ?? 1,
    initialPrice: item_5.bestListing?.pricePerItem.token.unit && item_5.bestListing.pricePerItem.token.address ? {
      unit: item_5.bestListing.pricePerItem.token.unit,
      contractAddress: item_5.bestListing.pricePerItem.token.address
    } : undefined,
    orderId: item_5.orderId
  }] : [];
}